import { render, staticRenderFns } from "./AppLoginSignup.vue?vue&type=template&id=3f541d91&"
import script from "./AppLoginSignup.vue?vue&type=script&lang=js&"
export * from "./AppLoginSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f541d91')) {
      api.createRecord('3f541d91', component.options)
    } else {
      api.reload('3f541d91', component.options)
    }
    module.hot.accept("./AppLoginSignup.vue?vue&type=template&id=3f541d91&", function () {
      api.rerender('3f541d91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/AppLoginSignup.vue"
export default component.exports